import { useNavigate, useParams } from "react-router";

import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import type { ParamParseKey } from "react-router";

export const useGetParams = () => {
	const { hotelID } = useParams<ParamParseKey<typeof PATHS.HOTEL.RESERVATION_PAGE.SNACK.LIST>>();

	const navigate = useNavigate();

	/**
	 *
	 * @todo hotelID ブランク時の振る舞いを設計
	 *
	 */
	if (!hotelID) {
		notifyUserEventInfo({
			title: "無効なURLです",
		});
		navigate(PATHS.TOP);
	}

	return {
		hotelID: hotelID!,
	};
};
